import * as z from "zod/v4";

export const disconnectRyderIntegration = {
  name: "disconnectRyderIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
